import { clamp01, smoothstep } from '../lib/math';
import type { Blendshapes } from './types';

const read = (bs: Blendshapes, key: string): number => clamp01(bs[key] ?? 0);

/**
 * Blendshapes → score de rire dans [0..1].
 *
 * - Le sourire est la base, pondéré vers le côté le MOINS souriant : un rictus
 *   d'un seul côté (tic nerveux) ne compte presque pas.
 * - Les joues plissées confirment un vrai sourire (sourire de Duchenne).
 * - `jawOpen` n'amplifie que si un sourire est déjà présent : on chante la
 *   comptine à voix haute, parler ne doit pas être pris pour un rire.
 */
export function laughScore(bs: Blendshapes): number {
  const left = read(bs, 'mouthSmileLeft');
  const right = read(bs, 'mouthSmileRight');
  const smile = 0.7 * Math.min(left, right) + 0.3 * Math.max(left, right);
  const cheek = (read(bs, 'cheekSquintLeft') + read(bs, 'cheekSquintRight')) / 2;
  const jaw = read(bs, 'jawOpen');
  const smileGate = smoothstep(0.1, 0.4, smile);
  return clamp01(0.75 * smile + 0.2 * cheek + 0.2 * jaw * smileGate);
}

/**
 * Blendshapes → score de clignement dans [0..1] : l'œil le PLUS fermé
 * l'emporte (un clin d'œil compte comme un clignement).
 */
export function blinkScore(bs: Blendshapes): number {
  return Math.max(read(bs, 'eyeBlinkLeft'), read(bs, 'eyeBlinkRight'));
}
